import { Link } from "react-router-dom";
import { Facebook, Youtube, MapPin, Mail, Phone, Clock } from "lucide-react";
import { CONTACT, LOGO_URL } from "../../lib/branches";

export default function Footer() {
  return (
    <footer className="bg-olive text-bone mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-5 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-14 h-14 bg-white overflow-hidden flex items-center justify-center">
              <img src={LOGO_URL} alt="ETI logo" className="w-full h-full object-contain" />
            </div>
            <div>
              <p className="font-heading font-bold text-lg">El-Shaddai Tabernacle</p>
              <p className="text-xs text-bone/70 tracking-widest uppercase">International</p>
            </div>
          </div>
          <p className="text-bone/80 max-w-md leading-relaxed">
            A house of faith called to <span className="font-semibold text-terracotta">Occupy and Build</span> —
            advancing the Kingdom of God across Mpumalanga, South Africa, and the nations.
          </p>
          <div className="flex items-center gap-3 mt-6">
            <a href="https://www.facebook.com/people/Elshaddai-Tabernacle-International-Nelspruit/100068296793353/" target="_blank" rel="noreferrer"
               className="w-11 h-11 border border-bone/30 hover:bg-terracotta hover:border-terracotta flex items-center justify-center transition-colors"
               data-testid="footer-social-facebook">
              <Facebook size={18} />
            </a>
            <a href="https://www.youtube.com/@ETIMBOMBELA" target="_blank" rel="noreferrer"
               className="w-11 h-11 border border-bone/30 hover:bg-terracotta hover:border-terracotta flex items-center justify-center transition-colors"
               data-testid="footer-social-youtube">
              <Youtube size={18} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="overline text-terracotta mb-4">Explore</h4>
          <ul className="space-y-2 text-bone/85 text-sm">
            <li><Link to="/sermons" className="hover:text-terracotta">Sermons</Link></li>
            <li><Link to="/events" className="hover:text-terracotta">Events</Link></li>
            <li><Link to="/youth" className="hover:text-terracotta">Youth</Link></li>
            <li><Link to="/prayers" className="hover:text-terracotta">Prayer</Link></li>
            <li><Link to="/bible-school" className="hover:text-terracotta">Bible School (EBI)</Link></li>
            <li><Link to="/locations" className="hover:text-terracotta">Find a Church</Link></li>
            <li><a href="https://shop.eti.co.za" target="_blank" rel="noreferrer" className="hover:text-terracotta">Store ↗</a></li>
          </ul>
        </div>

        <div>
          <h4 className="overline text-terracotta mb-4">Get Involved</h4>
          <ul className="space-y-2 text-bone/85 text-sm">
            <li><Link to="/membership" className="hover:text-terracotta">Membership</Link></li>
            <li><Link to="/join-team" className="hover:text-terracotta">Join a Team</Link></li>
            <li><Link to="/homecell" className="hover:text-terracotta">Join a Homecell</Link></li>
            <li><Link to="/counselling" className="hover:text-terracotta">Counselling</Link></li>
            <li><Link to="/giving" className="hover:text-terracotta">Give</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="overline text-terracotta mb-4">Visit / Contact</h4>
          <ul className="space-y-3 text-bone/85 text-sm">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-terracotta" /> {CONTACT.city}</li>
            <li className="flex items-start gap-2"><Clock size={16} className="mt-0.5 text-terracotta" /> Sun · 08:00 Intercession (Prayer) · 08:30 – 10:30 Service</li>
            <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5 text-terracotta" /> <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="hover:text-terracotta">{CONTACT.phone}</a></li>
            <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5 text-terracotta" /> <a href={`mailto:${CONTACT.email}`} className="hover:text-terracotta break-all">{CONTACT.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-bone/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-bone/60">
          <p>© {new Date().getFullYear()} El-Shaddai Tabernacle International. All rights reserved.</p>
          <Link to="/admin/login" className="hover:text-terracotta" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
